import { getApiOriginErrorMessage as errorMessage } from "./constants";

const getApiOriginError = apiOrigin => {
  if (!["string", "undefined"].includes(typeof apiOrigin)) {
    return errorMessage;
  }
};

export default getApiOriginError;
